/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsPublicSharedLinkService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getPublicSharedLinkRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsPublicSharedLinkService',
  rpcName: 'getPublicSharedLink',
  auth: 'external',
  fingerprint: 'Gn9f1ZFoAkImzG8--5KMxKDQX5owJ93G',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicSharedLinkDownloadUrlRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsPublicSharedLinkService',
  rpcName: 'getPublicSharedLinkDownloadUrl',
  auth: 'external',
  fingerprint: 'lwA9gzRL0s7oWfgH36DPCqDQX5owJ93G',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicFeaturesRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsPublicSharedLinkService',
  rpcName: 'getPublicFeatures',
  auth: 'external',
  fingerprint: 'U8mfPL3CxR7F9JQYK7QPBZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};